export default {"src":"/_next/static/media/option-premium.0bcc7537.svg","height":24,"width":24};